export const getAllUrlParams = (url?: string) => {
  const defaultURL = window.location.search;
  const searchParams = new URLSearchParams(url || defaultURL);
  const result: Record<string, string> = {};

  // @ts-expect-error searchParams iteration
  for (const param of searchParams) {
    result[param[0]] = param[1];
  }

  return result;
};
